import { createRoot } from 'react-dom/client';
import { Filters } from './filters';

// Render your React component instead
if(document.getElementById('app')) {
    const root = createRoot(document.getElementById('app'));

    root.render(
        <div>
            <Filters />
        </div>
    );
}


